module.exports = __webpack_public_path__ + "static/4103-b13c6e7deeb4c0d1c18d25b4b90a5535.png";